import type { Dispatch, SetStateAction } from 'react';
import { TableHead, TableHeader, TableRow } from '@ksyos/design-system';
import type { IEmploymentAndServiceRights } from '../ServiceOrganizationPractitioners';
import { translateKey } from '../../../../../translate';
import { SortDirection, toUpperCase } from '../../../../../utils/sortDirection';

interface IPractitionerTableHeadProps {
    employments: IEmploymentAndServiceRights[];
    index: number;
    setEmployments: Dispatch<SetStateAction<IEmploymentAndServiceRights[]>>;
    setSortDirection: Dispatch<SetStateAction<SortDirection>>;
    sort: (
        employmentAndServiceRights: IEmploymentAndServiceRights[],
        direction: SortDirection,
        sortOn: string
    ) => IEmploymentAndServiceRights[];
    sortDirection: SortDirection;
    sortKey: string;
}

const columns = [
    { name: 'name', sortable: true },
    { name: 'profession' },
    { name: 'rights' },
    { name: 'activeSince', sortable: true },
];

export function PractitionerTableHead(props: Readonly<IPractitionerTableHeadProps>) {
    const { setEmployments, sort, setSortDirection, index, sortDirection, employments, sortKey } = props;

    if (index !== 0) {
        return null;
    }

    return (
        <TableHead>
            <TableRow>
                {columns.map((header) => (
                    <TableHeader
                        isSortable={header.sortable}
                        isSortHeader={sortKey === header.name}
                        key={header.name}
                        onClick={() => onClickHeader(header.name, sortKey)}
                        sortDirection={sortKey === header.name ? toUpperCase(sortDirection) : undefined}
                    >
                        {translateKey(`serviceSettings.practitioners.${header.name}`)}
                    </TableHeader>
                ))}
            </TableRow>
        </TableHead>
    );

    function onClickHeader(name: string, sortedNameKey: string) {
        if (name === sortedNameKey) {
            const newSortDirection = sortDirection === SortDirection.asc ? SortDirection.desc : SortDirection.asc;
            setSortDirection(newSortDirection);
            setEmployments(sort(employments, newSortDirection, name));
        } else {
            setSortDirection(SortDirection.asc);
            setEmployments(sort(employments, SortDirection.asc, name));
        }
    }
}
